// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatInput_container__CLqyk","buttonContainer":"ChatInput_buttonContainer__7Mdni","label":"ChatInput_label__0aO66","input":"ChatInput_input__dOQrH"};